module.exports = __webpack_public_path__ + "static/flags/JE-b27bcee5a036dcb36bfc0b341a39c121.gif";